import React, { useEffect } from "react";
import Meta from "./../components/Meta";
import { useRouter } from "../util/router";
import Button from "react-bootstrap/Button";
import { useAuth } from "../util/auth";
import { useState } from "react";
import {
  useEventDivisions,
  useEventSideGames,
  useEventName,
  useUsersName,
} from "../util/db";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Section from "../components/Section";
import SectionHeader from "../components/SectionHeader";
import { requireAuth } from "./../util/auth";
import PromptUsersName from "../components/PromptUsersName";

function SignupPage(props) {
  const router = useRouter();
  const auth = useAuth();
  const uid = auth.user ? auth.user.uid : undefined;
  const eventId = router.query.id;

  //state
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [selectedSideGames, setSelectedSideGames] = useState([]);

  //for users name
  const { data: usersName = [] } = useUsersName(uid);

  //for users phone
  // const {
  //   data: usersPhone = [],
  //   // status: usersPhoneStatus,
  //   // error: usersPhoneError,
  // } = useUsersPhone(uid);

  //for event name
  const [eventName, setEventName] = useState("");

  const {
    data: eventname,
    status: eventnameStatus,
    // error: eventnameError,
  } = useEventName(eventId);
  //to set event name
  useEffect(() => {
    eventnameStatus !== "loading" &&
      eventname &&
      // eventnameStatus !== "loading" && eventname && eventName.length > 0 && (
      setEventName(eventname[0].name);
  }, [eventname, eventnameStatus]);

  //signupstate object
  const [signupObject, setSignupObject] = useState({
    division_id: null,
    event_divisions_id: null,
    division_name: "",
    division_cost: 0,
    side_games: [],
    side_games_cost: 0,
    events_id: null, // Initialize as null, will be set in useEffect
    user_id: uid,
    layout_id: null, // Add layout_id
  });
  // Update signupObject when router.query.id becomes available
  useEffect(() => {
    if (router.query.id && signupObject.events_id !== router.query.id) {
      // console.log("Updating signupObject with events_id:", router.query.id);
      setSignupObject((prev) => ({
        ...prev,
        events_id: router.query.id,
      }));
    }
  }, [router.query.id, signupObject.events_id]);

  //get divisions
  const {
    data: items,
    status: itemsStatus,
    // error: itemsError,
  } = useEventDivisions(eventId);

  //get side games
  const {
    data: sideGames,
    status: sideGamesStatus,
    // error: sideGamesError
  } = useEventSideGames(eventId);

  //totalcharge state
  const [totalCharge, setTotalCharge] = useState(
    signupObject.division_cost + signupObject.side_games_cost
  );
  //set division
  const handleSetDivision = (
    division_id,
    division_cost,
    division_name,
    event_divisions_id,
    layout_id
  ) => {
    //set division state
    setSelectedDivision(division_id);

    //set overall state object
    //copy signup object
    const newSignupObject = { ...signupObject };

    //copy new division and cost to new object
    newSignupObject.division_id = division_id;
    newSignupObject.division_cost = division_cost;
    newSignupObject.division_name = division_name;
    newSignupObject.event_divisions_id = event_divisions_id;
    newSignupObject.layout_id = layout_id; // Add layout_id

    //0verwrite existing signupobject
    setSignupObject(newSignupObject);

    //update total charge state
    setTotalCharge(signupObject.division_cost + signupObject.side_games_cost);
  };

  //set side game - now toggles selection
  const handleSetSideGame = (side_game_id, side_game_charge) => {
    // Check if side game is already selected
    if (isSelectedSideGame(side_game_id)) {
      // If selected, unselect it
      handleUnsetSideGame(side_game_id, side_game_charge);
      return;
    }

    //use side game state
    //copy side games object and add new side game
    const newSelectedSideGames = [...selectedSideGames, side_game_id];

    // set state to new object
    setSelectedSideGames(newSelectedSideGames);

    //use full object
    //copy signup object
    const newSignupObject = { ...signupObject };

    //add side game to array
    newSignupObject.side_games.push(side_game_id);
    newSignupObject.side_games_cost += side_game_charge;

    //0verwrite existing signupobject
    setSignupObject(newSignupObject);

    //update total charge state
    setTotalCharge(signupObject.division_cost + signupObject.side_games_cost);
  };

  // unset side game
  const handleUnsetSideGame = (remove_side_game, remove_side_game_cost) => {
    //use side game state
    const newSelectedSideGames = [...selectedSideGames];

    if (newSelectedSideGames.includes(remove_side_game)) {
      newSelectedSideGames.splice(
        newSelectedSideGames.indexOf(remove_side_game),
        1
      );
    }

    setSelectedSideGames(newSelectedSideGames);

    //use full object
    //copy signup object
    const newSignupObject = { ...signupObject };

    //remove side game from array
    const index = newSignupObject.side_games.indexOf(remove_side_game);
    if (index > -1) {
      newSignupObject.side_games.splice(index, 1);
    }

    //remove cost of side game from charge
    newSignupObject.side_games_cost -= remove_side_game_cost;

    //0verwrite existing signupobject
    setSignupObject(newSignupObject);

    //update total charge state
    setTotalCharge(signupObject.division_cost + signupObject.side_games_cost);
  };

  //return true if this is the selected division
  const isSelectedDivision = (this_division_id) => {
    if (selectedDivision === this_division_id) {
      return true;
    } else {
      return false;
    }
  };

  //return true if this is the selected sidegame
  const isSelectedSideGame = (this_sidegame_id) => {
    if (selectedSideGames.includes(this_sidegame_id)) {
      return true;
    } else {
      return false;
    }
  };
  const handleSignupClick = () => {
    // Validate that we have event_id before proceeding to payment
    const eventId = signupObject.events_id || signupObject.event_id;
    if (!eventId) {
      alert(
        "Error: Event ID is missing. Please refresh the page and try again."
      );
      return;
    }

    // Validate that we have layout_id before proceeding to payment
    if (!signupObject.layout_id) {
      alert(
        "Error: Please select a division first, or contact support if the division has no layout assigned."
      );
      return;
    }

    console.log("Signup click - sending signupObject:", signupObject);
    router.push("/payment", { signupObject });
  };

  //error handling
  // function ErrorHandler({error}) {
  //   return (
  //     <div role="alert">
  //       <p>An error occurred:</p>
  //       <pre>{error.message}</pre>
  //     </div>
  //   )
  // }

  // function Player({name}) {
  //   try {
  //     return <div>Hello, {name.toUpperCase()}</div>
  //   } catch (error) {
  //     return <ErrorHandler error={error} />
  //   }
  // }

  function checkForName() {
    if (usersName.length === 0) {
      return false;
    } else {
      return true;
    }
  }

  // function checkForPhone(){
  //   if(usersPhone.length === 0 ){
  //     return false
  //   }else{
  //     // console.log(usersPhone[0])
  //     if(usersPhone[0].phonenumber == null){
  //       return false
  //     }else{
  //       return true
  //     }
  //   }
  // }

  //useeffect to make totalcharge work
  useEffect(() => {
    // Update the document title using the browser API
    const $thistotalcost =
      signupObject.division_cost + signupObject.side_games_cost;
    setTotalCharge("Total Charge: $" + $thistotalcost);
  }, [signupObject]);

  return (
    <>
      <Meta title="Signup" />
      <Section
        bg="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
        textColor="white"
        size="sm"
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          minHeight: "auto",
          paddingTop: "0.5rem",
          paddingBottom: "1rem",
          marginTop: "0",
        }}
      >
        <Container style={{ paddingTop: "0" }}>
          <Row className="justify-content-center" style={{ marginTop: "0" }}>
            <Col xs={12} className="text-center" style={{ paddingTop: "0" }}>
              <div className="mb-3">
                <Button
                  variant="outline-light"
                  size="sm"
                  onClick={() => router.push(`/event?event=${eventId}`)}
                  style={{
                    borderColor: "rgba(255,255,255,0.5)",
                    color: "white",
                    fontSize: "0.9rem",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor =
                      "rgba(255,255,255,0.1)";
                    e.currentTarget.style.borderColor = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.borderColor = "rgba(255,255,255,0.5)";
                  }}
                >
                  <i className="fas fa-arrow-left mr-2"></i>
                  Back to Event
                </Button>
              </div>
              <h1
                className="display-4 font-weight-bold mb-3"
                style={{ color: "white", marginTop: "0", paddingTop: "0" }}
              >
                {eventName || "Event Signup"}
              </h1>
              <div
                className="bg-white rounded-pill px-4 py-3 d-inline-block shadow-lg mx-auto"
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  color: "#2D083F",
                  border: "3px solid rgba(255,255,255,0.8)",
                }}
              >
                <i className="fas fa-dollar-sign mr-2"></i>
                {totalCharge}
              </div>
              <p
                className="mt-3 mb-0"
                style={{ fontSize: "1.1rem", opacity: 0.9 }}
              >
                {sideGames && sideGames.length > 0
                  ? "Select your division and optional side games below"
                  : "Select your division below"}
              </p>
            </Col>
          </Row>
        </Container>
      </Section>
      {checkForName() ? <></> : <PromptUsersName />}
      {/* {checkForPhone() ? <center><h6>Phone Number: {usersPhone[0].phonenumber} </h6></center> : <PromptUsersPhone />} */}
      <Container className="mb-1">
        <SectionHeader
          title="Choose Your Division"
          size={2}
          spaced={false}
          className="text-center"
        />
        <div className="d-flex flex-column gap-2">
          {itemsStatus !== "loading" &&
            items &&
            items.length > 0 &&
            items.map((item, index) => (
              <div
                key={index}
                className="d-flex align-items-center justify-content-between p-3 rounded shadow border"
                onClick={() =>
                  handleSetDivision(
                    item.division_id,
                    item.division_cost,
                    item.divisions.name,
                    item.event_divisions_id,
                    item.layout_id
                  )
                }
                style={{
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  transform: isSelectedDivision(item.division_id)
                    ? "translateY(-3px)"
                    : "translateY(-1px)",
                  boxShadow: isSelectedDivision(item.division_id)
                    ? "0 6px 20px rgba(45, 8, 63, 0.3)"
                    : "0 2px 10px rgba(0,0,0,0.1)",
                  background: isSelectedDivision(item.division_id)
                    ? "linear-gradient(135deg, #2D083F 0%, #4A1A5C 100%)"
                    : "white",
                  borderWidth: "2px",
                  borderColor: isSelectedDivision(item.division_id)
                    ? "#2D083F"
                    : "#e0e0e0",
                  borderStyle: "solid",
                  minHeight: "70px",
                }}
                onMouseEnter={(e) => {
                  if (!isSelectedDivision(item.division_id)) {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 15px rgba(45, 8, 63, 0.2)";
                    e.currentTarget.style.borderColor = "#2D083F";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSelectedDivision(item.division_id)) {
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow =
                      "0 2px 10px rgba(0,0,0,0.1)";
                    e.currentTarget.style.borderColor = "#e0e0e0";
                  }
                }}
              >
                <div className="d-flex align-items-center">
                  {isSelectedDivision(item.division_id) && (
                    <i
                      className="fas fa-check-circle me-3"
                      style={{ color: "#4CAF50", fontSize: "1.5rem" }}
                    ></i>
                  )}
                  <h5
                    className="mb-0 font-weight-bold"
                    style={{
                      color: isSelectedDivision(item.division_id)
                        ? "white"
                        : "#2D083F",
                      fontSize: "1.1rem",
                    }}
                  >
                    {item.divisions.name}
                  </h5>
                </div>
                <div className="d-flex flex-column align-items-end">
                  <h4
                    className="mb-0 font-weight-bold"
                    style={{
                      color: isSelectedDivision(item.division_id)
                        ? "#FFD700"
                        : "#2D083F",
                      fontSize: "1.5rem",
                    }}
                  >
                    ${item.division_cost}
                  </h4>
                  <small
                    style={{
                      color: isSelectedDivision(item.division_id)
                        ? "rgba(255,255,255,0.8)"
                        : "#666",
                    }}
                  >
                    {isSelectedDivision(item.division_id)
                      ? "Selected"
                      : "Click to select"}
                  </small>
                </div>
              </div>
            ))}
        </div>
      </Container>
      {/* side game section - only show if there are side games */}
      {sideGamesStatus !== "loading" && sideGames && sideGames.length > 0 && (
        <Container className="mb-1" style={{ marginTop: "1rem" }}>
          <SectionHeader
            title="Side Games"
            // subtitle="Optional add-ons to enhance your experience"
            size={2}
            spaced={false}
            className="text-center"
          />
          <div className="d-flex flex-column gap-2">
            {sideGames.map((sideGame, index) => (
              <div
                key={index}
                className="d-flex align-items-center justify-content-between p-3 rounded shadow border"
                onClick={() =>
                  handleSetSideGame(sideGame.id, sideGame.side_game_price)
                }
                style={{
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  transform: isSelectedSideGame(sideGame.id)
                    ? "translateY(-3px)"
                    : "translateY(-1px)",
                  boxShadow: isSelectedSideGame(sideGame.id)
                    ? "0 6px 20px rgba(76, 175, 80, 0.3)"
                    : "0 2px 10px rgba(0,0,0,0.1)",
                  background: isSelectedSideGame(sideGame.id)
                    ? "linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%)"
                    : "white",
                  borderWidth: "2px",
                  borderColor: isSelectedSideGame(sideGame.id)
                    ? "#4CAF50"
                    : "#e0e0e0",
                  borderStyle: "solid",
                  minHeight: "70px",
                }}
                onMouseEnter={(e) => {
                  if (!isSelectedSideGame(sideGame.id)) {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 15px rgba(76, 175, 80, 0.2)";
                    e.currentTarget.style.borderColor = "#4CAF50";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSelectedSideGame(sideGame.id)) {
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow =
                      "0 2px 10px rgba(0,0,0,0.1)";
                    e.currentTarget.style.borderColor = "#e0e0e0";
                  }
                }}
              >
                <div className="d-flex align-items-center">
                  {isSelectedSideGame(sideGame.id) && (
                    <i
                      className="fas fa-check-circle me-3"
                      style={{ color: "#FFD700", fontSize: "1.5rem" }}
                    ></i>
                  )}
                  <div className="d-flex align-items-center">
                    <i
                      className="fas fa-star me-3"
                      style={{
                        color: isSelectedSideGame(sideGame.id)
                          ? "#FFD700"
                          : "#FFC107",
                        fontSize: "1.2rem",
                      }}
                    ></i>
                    <h5
                      className="mb-0 font-weight-bold"
                      style={{
                        color: isSelectedSideGame(sideGame.id)
                          ? "white"
                          : "#2D083F",
                        fontSize: "1.1rem",
                      }}
                    >
                      {sideGame.side_game_name}
                    </h5>
                  </div>
                </div>
                <div className="d-flex flex-column align-items-end">
                  <h4
                    className="mb-0 font-weight-bold"
                    style={{
                      color: isSelectedSideGame(sideGame.id)
                        ? "#FFD700"
                        : "#4CAF50",
                      fontSize: "1.5rem",
                    }}
                  >
                    ${sideGame.side_game_price}
                  </h4>
                  <small
                    style={{
                      color: isSelectedSideGame(sideGame.id)
                        ? "rgba(255,255,255,0.8)"
                        : "#666",
                    }}
                  >
                    {isSelectedSideGame(sideGame.id)
                      ? "Added ✓"
                      : "Click to add"}
                  </small>
                </div>
              </div>
            ))}
          </div>
        </Container>
      )}
      <Container
        className="mt-3"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          variant={props.buttonColor}
          size="lg"
          disabled={!signupObject.events_id && !signupObject.event_id}
          onClick={() => {
            handleSignupClick();
          }}
        >
          {!signupObject.events_id && !signupObject.event_id
            ? "Loading..."
            : "Signup!"}
        </Button>
      </Container>
    </>
  );
}

export default requireAuth(SignupPage);
